import { useEffect, useRef, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router-dom";
import { createPromiseRequest } from "@/components/lms/lms.utils";
import { getLmsOrigin } from "@/components/lms/lmsScormRuntime";

interface PreviewLaunch {
  variant_id: string;
  preview_token: string;
}

export default function LmsScormPreviewLaunch() {
  const { variantId } = useParams<{ variantId: string }>();
  const { t } = useTranslation();
  const started = useRef(false);
  const [error, setError] = useState(false);
  const isStaffPortal = window.location.hostname.split(".")[0] === "admin";

  useEffect(() => {
    if (!isStaffPortal || !variantId || started.current) return;
    started.current = true;
    void createPromiseRequest<{ data: PreviewLaunch }>({
      entity: "courseLanguageVariant",
      entityId: variantId,
      method: "post",
      additionalRouteParts: { start_scorm_preview: "/" },
      disableGlobalSpinner: true,
    })
      .then(({ data }) => {
        window.location.replace(
          `${getLmsOrigin()}/api/v1/courseLanguageVariant/${encodeURIComponent(data.variant_id)}/preview/${encodeURIComponent(data.preview_token)}/`,
        );
      })
      .catch(() => setError(true));
  }, [isStaffPortal, variantId]);

  if (!isStaffPortal) return <Navigate to="/" replace />;
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 2,
        p: 3,
      }}>
      {error ? (
        <Typography role="alert">{t("scorm_preview_launch_error")}</Typography>
      ) : (
        <>
          <CircularProgress />
          <Typography>{t("scorm_preview_preparing")}</Typography>
        </>
      )}
    </Box>
  );
}
